import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { createApi } from '../services/api.js';

export function CheckoutSuccessPage({ token }: { token: string }) {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<'verifying' | 'success' | 'already'>('verifying');
  const [tier, setTier] = useState<string | null>(null);

  useEffect(() => {
    const sessionId = searchParams.get('session_id');
    const upgraded = searchParams.get('upgraded');

    if (upgraded === 'true') {
      // Inline upgrade (subscription swap) — no session to verify
      setStatus('success');
      return;
    }

    if (!sessionId || !token) {
      setStatus('success');
      return;
    }

    const api = createApi(token);
    api.verifyCheckout(sessionId).then((res) => {
      if (res.ok) {
        setTier(res.data.tier ?? null);
        setStatus(res.data.synced ? 'success' : 'already');
      } else {
        // Verification failed but checkout may still be valid (webhook will handle it)
        setStatus('success');
      }
    });
  }, [token, searchParams]);

  return (
    <div className="py-16 text-center">
      {status === 'verifying' ? (
        <>
          <div className="mx-auto mb-4 h-6 w-6 animate-spin rounded-full border-2 border-surface-300 border-t-brand" />
          <p className="text-sm text-ink-muted">Confirming your upgrade...</p>
        </>
      ) : (
        <>
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-emerald-100">
            <svg className="h-6 w-6 text-emerald-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <h1 className="text-xl font-bold text-ink">Upgrade complete</h1>
          <p className="mt-2 text-sm text-ink-muted">
            {tier ? (
              <>Your plan is now <span className="font-semibold capitalize">{tier}</span>.</>
            ) : (
              'Your plan is now active.'
            )}
          </p>
          <Link
            to="/pricing"
            className="mt-6 inline-block rounded-lg bg-brand px-6 py-2.5 text-sm font-semibold text-white hover:bg-red-700 transition"
          >
            View your plan
          </Link>
        </>
      )}
    </div>
  );
}
